// =============== ADAPTIVE QUESTION SELECTOR ===============
// Intelligent question selection based on user performance

export const selectNextQuestion = ({ module, allQuestions, askedQuestionIds, answersById }) => {
  const unaskedQuestions = allQuestions.filter(q => !askedQuestionIds.includes(q.id));
  
  if (unaskedQuestions.length === 0) return null;
  
  const performance = calculatePerformance(module, answersById, allQuestions);
  const targetDifficulty = getDifficultyLevel(performance);
  
  const matchingQuestion = unaskedQuestions.find(q => q.difficulty === targetDifficulty);
  return matchingQuestion || unaskedQuestions[0];
};

function calculatePerformance(module, answersById, allQuestions) {
  const answeredQuestions = Object.keys(answersById);
  if (answeredQuestions.length === 0) return 0.5;
  
  if (module === 'cognitive') {
    let correct = 0;
    answeredQuestions.forEach(qId => {
      const question = allQuestions.find(q => q.id === qId);
      if (question && question.correctAnswer !== undefined) {
        if (answersById[qId] === question.correctAnswer) correct++;
      }
    });
    return correct / answeredQuestions.length;
  }
  
  let totalScore = 0;
  let count = 0;
  answeredQuestions.forEach(qId => {
    const question = allQuestions.find(q => q.id === qId);
    const answer = answersById[qId];
    if (question && question.type === 'likert' && typeof answer === 'number') {
      totalScore += answer / (question.scale || 5);
      count++;
    }
  });
  
  return count > 0 ? totalScore / count : 0.5;
}

function getDifficultyLevel(performance) {
  if (performance < 0.4) return 'easy';
  if (performance > 0.7) return 'hard';
  return 'medium';
}
